import { IApplicationState } from '../../types/redux';

export function selectParentRegion(state: IApplicationState) {
  return state.geoLocation.currentRegion.parentId;
}
